module.exports = __webpack_public_path__ + "static/media/adrienne-mackey.9f380cb5.md";